<template>
	<v-container fluid>
		<v-row>
			<v-col cols="8">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="12">
				<v-data-table dense :headers="headers" :loading="loading" :items="members" :items-per-page="15" :search="search" class="elevation-1">
					<template v-slot:item.firstName="{item}">
						<a href="javascript:void(0)" @click="manageLoans(item)" class="info--text">{{ item.firstName }}</a>
					</template>
					<template v-slot:item.lastName="{item}">
						<a href="javascript:void(0)" @click="manageLoans(item)" class="info--text">{{ item.lastName }}</a>
					</template>
					<template v-slot:item.regDate2_Persian.date="{item}">
						<div style="direction: ltr;">{{ `${item.regDate2_Persian.date} ${item.regDate2_Persian.time != '00:00:00' ? item.regDate2_Persian.time : ''}` }}</div>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<confirm-dlg ref="confirm" />

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<ManageLoan ref="manageLoan" v-if="dialogLoansManager" :data="{member:selectedMember}" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'AgentRequests',
		props: {
			marketer: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ManageLoan: () => import('@/views/admin/ManageLoan.vue'),
		},
		data() {
			return {
				errorMessages: '',
				search: '',
				loading: false,
				selectedMember: {},
				dialogLoansManager: false,
				headers: [
					{
						text: 'نام',
						align: 'start',
						sortable: true,
						value: 'firstName',
					}, {
						text: 'نام خانوادگی',
						align: 'start',
						sortable: true,
						value: 'lastName',
					}, {
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'موبایل',
						align: 'center',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'تاریخ عضویت',
						align: 'center',
						sortable: true,
						value: 'regDate2_Persian.date',
					}
				],
				members: [],
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {

		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/member/ListByMarketerId/' + this.marketer.id, null)
					.then(response => {
						this.members = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			manageLoans(item) {
				this.selectedMember = item
				this.dialogLoansManager = true
			},
		}
	}
</script>
<style>
</style>
